import { Injectable } from '@angular/core';

@Injectable()
export class CurrencyService {
	public round(value: number, decimals: number = 2): number {
		return Number(Math.round(parseFloat(value + 'e' + decimals)) + 'e-' + decimals);
	}
}
